import produce, { Draft } from 'immer';

import { Action } from '../../actions';
import {
    ADD_PHRASES_GENERATOR_GROUP,
    CHANGE_PHRASES_GENERATOR_PHRASES,
    REMOVE_PHRASES_GENERATOR_GROUP
} from '../../actions/phrases-selector/generator';
import { PhrasesSelectorsState } from '../../typings/state';

export const phrasesSelectorGeneratorReducer = (
    state: PhrasesSelectorsState,
    action: Action
): PhrasesSelectorsState => {
    return produce(state, (draftState: Draft<PhrasesSelectorsState>) => {
        switch (action.type) {
            case ADD_PHRASES_GENERATOR_GROUP: {
                const groupData = draftState.persistentData[action.groupId];

                groupData.generator.groups.push('');
                break;
            }
            case REMOVE_PHRASES_GENERATOR_GROUP: {
                const groupData = draftState.persistentData[action.groupId];

                groupData.generator.groups.splice(action.index, 1);
                break;
            }
            case CHANGE_PHRASES_GENERATOR_PHRASES: {
                const { groupId, groupIndex, phrases } = action;
                const groupData = draftState.persistentData[groupId];

                groupData.generator.groups[groupIndex] = phrases;
                break;
            }
            default:
                break;
        }
    });
};
